<template>
  <div class="card card-with-shadow border-0 h-100 employee-preview-card">
    <span>{{location}}</span>
    <div class="card-body position-relative d-flex flex-column justify-content-between">
      <div v-if="showAction" class="dropdown options-dropdown position-absolute">
        <button type="button"
                class="btn-option btn d-flex align-items-center justify-content-center"
                data-toggle="dropdown">
          <app-icon name="more-horizontal"/>
        </button>
        <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
          <a class="dropdown-item px-4 py-2"
             href="#"
             v-for="(action,index) in actions"
             :key="index"
             v-if="checkIfVisible(action, location)"
             @click.prevent="callAction(action)">
            {{ action.title }}
          </a>
        </div>
      </div>
      <div class="text-center">

        <p class="mb-2">{{ location.name ? location.name : location.alias }}</p>
        <p class="mb-2 font-size-80 text-muted"
           data-toggle="tooltip"
           data-placement="top"
           :title="$t('designation')"
        >
          {{ $optional(location, 'designation', 'name') }}
        </p>
        <p class="mb-0 font-size-80 text-muted"
           data-toggle="tooltip"
           data-placement="top"
           :title="$t('employee_id')"
        >
          {{ $optional(location, 'profile', 'employee_id') }}
        </p>

        <div v-if="location.employment_status" class="my-3">
          <app-employee-status
              :row-data="employee"
              :alignment-class="'justify-content-center'"
          />
        </div>

        <div class="text-muted">
          <p class="mb-2"
             data-toggle="tooltip"
             data-placement="top"
             :title="$t('department')"
          >
            {{ $optional(location, 'department', 'name') }}
          </p>
          <p class="mb-0"
             data-toggle="tooltip"
             data-placement="top"
             :title="$t('working_shift')"
          >
            {{ $optional(location, 'working_shift', 'name') }}
          </p>
        </div>
      </div>
      <div class="text-center mt-4">
<!--        <a :href="profileUrl"-->
<!--           class="btn btn-transparent-primary rounded-pill">-->
<!--          {{ $t('view_details') }}-->
<!--        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import {EMPLOYEES_PROFILE} from "../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
  name: "LocationPreviewCard",
  extends: CoreLibrary,
  props: {
    location: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      require: true
    },
    showAction: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      require: true
    }
  },
  methods: {
    callAction(action) {
      this.$emit('action-' + this.id, this.location, action, true)
    },
    checkIfVisible(action, location) {
      if (this.isFunction(action.modifier)) {
        return action.modifier(location);
      }
      return true;
    },
  },
  computed: {
    // profileUrl() {
    //   return urlGenerator(`${EMPLOYEES_PROFILE}/${this.location.id}/profile`)
    // }
  }
}
</script>